import React from 'react';
import Router from './pages/Router';
import rootStore from './stores/RootStore';

// Rendering Router component and sending rootStore as props.
export default () => <Router {...rootStore}/>;